// Module
var code = `<div class='customer-loans-gl-payment'>
  <form name="\$ctrl.form">
    <sub-header header="'General Ledger payment'" ></sub-header>
    <amortization-payment
      loan="\$ctrl.loan"
      payment-request="\$ctrl.paymentRequest"
      collect-official-receipt="true"
      custom-payment-allowed="\$ctrl.canPerformCustomPayment"
      allow-overpayment="true">
    </amortization-payment>

    <gl-payment operation="\$ctrl.operation" branch="\$ctrl.branch" remarks="\$ctrl.remarks" action-type="'LOAN_GL_PAYMENT'"></gl-payment>

    <div class="buttons">
      <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
      <button type="button" class="btn btn-print" ng-click="\$ctrl.print()">Print</button>
      <button type="button" class="btn btn-success" ng-click="\$ctrl.pay()" ng-disabled="\$ctrl.form.\$invalid">
        Confirm payment
      </button>
    </div>
  </form>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/gl-payment/loan-gl-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;